<template>
    <div class="SJMLoading"
         :style="`z-index: ${zIndex};position: ${fixed?'fixed':'absolute'};background-color: ${backgroundColor};`">
        <div v-if="type === 'sjm'"
             class="loadingBox"
             :style="{top:top,transform:'scale(' + scale + ') translate(-50%,-50%)'}">
            <div class="loadingText">
                <img v-if="skin === '1'"
                     src="@/assets/img/plugin/sjmLoading/loading_text1.png"
                     alt="">
                <img v-else-if="skin === '2'"
                     src="@/assets/img/plugin/sjmLoading/loading_text2.png"
                     alt="">
            </div>
            <div class="loadingCircle">
                <img v-if="skin === '1'"
                     src="@/assets/img/plugin/sjmLoading/loading_circle1.png"
                     alt="">
                <img v-else-if="skin === '2'"
                     src="@/assets/img/plugin/sjmLoading/loading_circle2.png"
                     alt="">
            </div>
            <div class="loadingLogo">
                <img v-if="skin === '1'"
                     src="@/assets/img/plugin/sjmLoading/sjm_logo1.png"
                     alt="">
                <img v-else-if="skin === '2'"
                     src="@/assets/img/plugin/sjmLoading/sjm_logo2.png"
                     alt="">
            </div>
        </div>
        <div v-if="type==='chrome'"
             class="loadingBoxChrome"
             :style="{top: top,transform: `translate(-50%, -50%) scale(${scale})`}">
            <img src="@/assets/img/plugin/sjmLoading/throbber_small.svg">
            <span v-if="text">{{text}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SJMLoading',
        props: {
            // 加载中类型 '' or 'chrome'
            type: {
                type: String,
                default: 'sjm'
            },
            // 加载中文字
            text: {
                type: String,
                default: ''
            },
            // 定位高度
            top: {
                type: String,
                default: '45%'
            },
            // zIndex
            zIndex: {
                type: String,
                default: '3'
            },
            // 全屏定位
            fixed: {
                type: Boolean,
                default: false
            },
            // 缩放
            scale: {
                type: String,
                default: '1'
            },
            // 背景色
            backgroundColor: {
                type: String,
                default: 'rgba(255,255,255,0.98)'
            },
            // 皮肤 '1' or '2'
            skin: {
                type: String,
                default: '1'
            },
        }
    };
</script>

<style lang="scss" scoped>

    @keyframes loadingCircleAni {
        0% {
            transform: rotate(80deg);
        }

        100% {
            transform: rotate(-280deg);
        }
    }

    @keyframes loadingBoxAni {
        0% {
            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        88% {
            opacity: 1;
        }

        100% {
            opacity: 1;
        }
    }

    .SJMLoading {
        position: absolute;
        top: 0;
        left: 0;
        box-sizing: content-box !important;
        width: 100%;
        height: 100%;

        * {
            box-sizing: content-box !important;
        }

        .loadingBox {
            position: absolute;
            left: 50%;
            width: 180px;
            height: 180px;
            border-radius: 5%;
            opacity: 1;
            animation: loadingBoxAni 2.5s;

            .loadingText {
                position: absolute;
                top: 73.75%;
                left: 18.625%;
                width: 64.25%;
                height: 18%;

                img {
                    width: 100%;
                    height: auto;
                }
            }

            .loadingCircle {
                position: absolute;
                top: 9.5%;
                left: 16%;
                width: 68%;
                height: 68%;
                animation: loadingCircleAni 2s linear infinite;

                img {
                    width: 100%;
                    height: auto;
                }
            }

            .loadingLogo {
                position: absolute;
                top: 31%;
                left: 36.7%;
                width: 28%;
                height: 28.75%;

                img {
                    width: 100%;
                    height: auto;
                }
            }
        }

        .loadingBoxChrome {
            position: relative;
            top: 50%;
            left: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;

            @keyframes rotate {
                from {
                    transform: rotate(0deg);
                }

                to {
                    transform: rotate(360deg);
                }
            }

            img {
                width: 30px;
                height: auto;
                animation-name: rotate;
                animation-duration: 1568.63ms;
                animation-timing-function: linear;
                animation-iteration-count: infinite;
            }

            span {
                display: block;
                margin-top: 8px;
                color: #4285f4;
            }
        }
    }
</style>